import React from 'react';
import ProtocolNodeForm from 'routes/surface/components/node-modal-form/components/protocol-node-modal/components/protocol-node-form';
import { useOnSurfaceNodeSave } from 'components/canvas/hooks/use-on-surface-node-save';
import useSurfaceNodeInitialValuesFromServer from 'routes/surface/components/node-modal-form/hooks/use-surface-node-initial-values-from-server';
import useMutation from 'hooks/use-mutation';
import { createSurfaceProtocolNodeMutation } from 'graphql/surface-node/mutations/surface-protocol-node/create-surface-protocol-node';
import { updateSurfaceProtocolNodeMutation } from 'graphql/surface-node/mutations/surface-protocol-node/update-surface-protocol-node';
import { toast } from 'services/toast';
import { withModal } from 'hoc';
import { pick } from 'lodash';
import { ModalContext } from 'hoc/with-modal';
import { SurfaceProtocolNode } from 'graphql/types';
import { NodeModalInput } from 'types';

export interface ProtocolNodeModalProps {
  data: NodeModalInput<SurfaceProtocolNode>;
  modal: ModalContext;
}

const defaultProps = {};

function ProtocolNodeModal(props: ProtocolNodeModalProps) {
  const { initialValues: data } = useSurfaceNodeInitialValuesFromServer(
    props.data,
  ) as any;

  const onSurfaceNodeCreate = useOnSurfaceNodeSave('createSurfaceProtocolNode');

  const onSurfaceNodeUpdate = useOnSurfaceNodeSave('updateSurfaceProtocolNode');

  const [createSurfaceNode] = useMutation(createSurfaceProtocolNodeMutation, {
    update: onSurfaceNodeCreate as any,
  });

  const [updateSurfaceNode] = useMutation(updateSurfaceProtocolNodeMutation, {
    update: onSurfaceNodeUpdate as any,
  });

  function onSubmit(values, { setSubmitting }) {
    const saveOperation = data.id ? updateSurfaceNode : createSurfaceNode;

    const keys = data.id ? ['id', 'name'] : ['name', 'surface', 'position','comment', 'shareEmail'];

    const input = pick(values, keys);

    return saveOperation({ variables: { input } }).then((response) => {
      if (response.isFailure) {
        setSubmitting(false);
        toast.error(response.getErrorMessage());

        return response;
      }

      props.modal.hide();

      return response;
    });
  }

  return (
    <ProtocolNodeForm
      onSubmit={onSubmit}
      data={data}
      onCancel={props.modal.hide}
    />
  );
}

ProtocolNodeModal.defaultProps = defaultProps;

export default withModal(ProtocolNodeModal);
